export const typeIconList = [
    'requirement-add-fill', 'requirement-report-fill', 'requirement-compass-fill',
    'requirement-star-fill', 'requirement-human-fill', 'requirement-cycle-fill', 'requirement-transport-fill',
    'requirement-tool-fill', 'requirement-business-fill', 'requirement-quick-fill', 'requirement-shop-fill',
    'requirement-finance-fill', 'requirement-grow-fill', 'requirement-chart-fill', 'requirement-building-fill',
    'requirement-feedback-fill'
];

export const typeIconColorMap = {
    "requirement-add-fill": "#027042",
    "requirement-report-fill": "#0068FF",
    "requirement-shop-fill": "#FF8BBF",
    "requirement-quick-fill": "#FFD000",
    "requirement-feedback-fill": "#A3CE28",
    "requirement-chart-fill": "#0097FF",
    "requirement-building-fill": "#00BA78",
    "requirement-human-fill": "#C286FF",
    "requirement-transport-fill": "#32C7F4",
    "requirement-finance-fill": "#FF7A34",
    "requirement-tool-fill": "#00B3B7",
    "requirement-compass-fill": "#B20910",
    "requirement-business-fill": "#947169",
    "requirement-cycle-fill": "#5162FF",
    "requirement-star-fill": "#AD6200",
    "requirement-grow-fill": "#7E84FF"
}